import serverURL from "api/auth/auth";

/**
 * Base URL of the FMS rental-agreement PDF viewer (`/pdf?agreement=`) for the
 * current environment, derived from the API host (`serverURL`).
 *
 * Why not `process.env.REACT_APP_ENV`? The previous per-call switch only
 * handled "dev"/"stage" and fell through to the prod host for everything else.
 * The QA build does not set a "qa" env value, so on QA the agreement iframe
 * loaded prod's `/pdf` — which cannot resolve the QA booking/company and
 * bounces the user to the 1NOW sign-in page (1NOW-1239). `serverURL` is pinned
 * correctly per branch (QA -> api-qa-fleet-management), so it is the reliable
 * signal for the matching FMS host.
 */
export const getAgreementPdfBase = (): string => {
  const api = serverURL ?? "";
  if (api.includes("api-qa")) return "https://qa.1now.app/pdf?agreement=";
  if (api.includes("api-stage")) return "https://stage.1now.app/pdf?agreement=";
  if (api.includes("fleet-management-dev"))
    return "https://dev.1now.app/pdf?agreement=";
  return "https://1now.app/pdf?agreement=";
};
